import { mediaCards } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">精彩预告</h2>
            <p className="text-sm text-foreground-500 mt-2">最新电影预告片与幕后花絮抢先看</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {mediaCards.map((card) => (
            <div key={card.id} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden aspect-video bg-background-200">
                <img src={card.imageUrl} alt={card.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }} />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-full bg-black/50 text-white text-xs">{card.tag}</span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 px-2 py-1 rounded-md bg-black/70 text-white text-xs">
                  <i className="ri-play-fill"></i>
                  {card.duration}
                </div>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mt-3 line-clamp-2">{card.title}</h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{card.desc}</p>
              <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{card.views}</span>
                <span>{card.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}